import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { LOGIN, loginRequest } from '../../constants';
import { useMsal } from '@azure/msal-react';
import { bindActionCreators } from 'redux';
import { ContactsApiProvider } from '../../services';
import logo from 'assets/img/logo-xomePro.png';
import { Link } from 'react-router-dom';
import { acceptTerms, customModalActions, logout } from '../../actions';

const AzureB2C = ({ ...props }) => {
  const SUCCESS = 0;
  const UNKNOWN_ERROR = 1;
  const UNAUTHORIZED = 401;
  const INTERNAL_SERVER_ERROR = 500;

  const { instance, accounts } = useMsal();
  const [activeAccount, setActiveAccount] = useState(null);
  const [error, setError] = useState(SUCCESS);
  const [gotToken, setGotToken] = useState(false);
  const [redirectFailure, setRedirectFailure] = useState(false);

  useEffect(() => {
    setError(SUCCESS);
    if(instance) {
      let account = instance.getActiveAccount();
      setActiveAccount(account);
      if(account != null) {
        instance.acquireTokenSilent({
            account: accounts[0],
            scopes: ["openid", "profile"]
        }).then((response) => {
          setGotToken(true);
          props.contactsApiLogin(response.idToken).then((data) => {
            props.updateCustomModal(true, LOGIN.LOGIN_TERMS_TITLE,
              LOGIN.LOGIN_TERMS_BODY,
              () => {
                props.acceptTerms();
                props.history.push('/dashboard');
              }, props.logout, props.hideCustomModal, false, '', 'ACCEPT', 'DECLINE', true);
          }).catch((error) => {
            if(error?.response?.status === UNAUTHORIZED || error?.response?.status === INTERNAL_SERVER_ERROR)
              setError(error?.response?.status);
            else 
              setError(UNKNOWN_ERROR);
          })
        }).catch((e) => {
          console.log("Unexpected error ", e);
          setError(UNKNOWN_ERROR);
        });
      } else {
        setError(SUCCESS);
        setTimeout(() => {
          login(true);
        }, 1000);
      }
    }  
  }, [instance, accounts]);

  useEffect(() => {
    if(gotToken === false && redirectFailure === true) {
      const timeoutId = setTimeout(() => {
        if(gotToken === false && redirectFailure === true) {
          login(true);
          setError(UNKNOWN_ERROR);
        }
      }, 5000);
      return () => clearTimeout(timeoutId);
    }
  }, [gotToken, redirectFailure]);

  const login = (optional) => {
    if(optional === true && activeAccount != null)
      return;
    setError(SUCCESS);
    instance.loginRedirect(loginRequest).catch((error) => {
      console.log(error);
      setRedirectFailure(true);
    });
  };

  const showLoadingMessage = (message) => {
    return <div className="loader-container">
              <div className="loader">
                  <div className="spinner"></div>
                  <p>{message}</p>
              </div>
            </div>;
  };

  const loggedIn = () => {
    return showLoadingMessage(`Hi ${activeAccount?.name}, Please wait while we log you in`);
  };

  const nonLoggedIn = () => {
    return showLoadingMessage("Please wait while we redirect to Azure B2C ...");
  };

  const logout = () => {
    if(instance)
      instance.logoutRedirect();
  };

  const showError = () => {
    return  <>
              <div className="error-container">
                <div className="error">
                  <div className="error-icon">&#9888;</div>
                  <p>Hi {activeAccount?.name}, </p>
                  {
                    error === UNAUTHORIZED &&
                    <p>You do not have access to use this application. Please contact Concierge for more information.</p>
                  }
                  {
                    (error === INTERNAL_SERVER_ERROR || error === UNKNOWN_ERROR) &&
                    <p>There is an unexpected error. Please reload the page and try again. If the issue persists, please contact the customer support or concierge.</p>
                  }
                </div>
                  <div className="additional-links">
                    {
                      activeAccount != null 
                      ? <div className='pd-10'><a className="test" onClick={logout}>Logout</a></div>
                      : <div className='pd-10'><a className="test" onClick={() => login(false)}>Try Logging in Again</a></div>
                    }
                  </div>
              </div>
            </>;
  };

  return (
    <div className='login-background background-header bg_img'>
      <div className='header-logo'>
        <img className='header-logo-image' src={logo} />
      </div>
      {
        error !== SUCCESS ? 
          showError()
        : (activeAccount != null 
          ? loggedIn()
          : nonLoggedIn())
      }
    </div>
  );
};

AzureB2C.propTypes = {
  contactsApiLogin: PropTypes.func.isRequired,
  updateCustomModal: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired,
  hideCustomModal: PropTypes.func.isRequired,
  acceptTerms: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = dispatch => ({
  contactsApiLogin: bindActionCreators(ContactsApiProvider.azureB2CLogin, dispatch),
  updateCustomModal: bindActionCreators(customModalActions.updateCustomModal, dispatch),
  hideCustomModal: bindActionCreators(customModalActions.hideCustomModal, dispatch),
  logout: bindActionCreators(logout, dispatch),
  acceptTerms: bindActionCreators(acceptTerms, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AzureB2C));
